import { version } from "react";

const translations = {
	ar: {
		title: "قائمة المهام",
		dark: "🌙 الوضع الليلي",
		light: "☀️ الوضع النهاري",
		placeholder: "أدخل مهمة جديدة...",
		add: "إضافة",
		noTasks: "لا توجد مهام حالياً",
		all: "الكل",
		incomplete: "غير مكتملة",
		done: "مكتملة",
		noOfAll: "عدد المهام الكلية:",
		noOfDone: "عدد المهام المكتملة:",
		noOfNot: "عدد المهام غير مكتملة:",
		creator: "تم إنشاء هذا الموقع بواسطة : حازم عبدالله",
		enterValidTask: "! الرجاء إدخال مهمة",
		wannaDeleteThisTask: "هل أنت متأكد من حذف هذه المهمة؟",
		deleteAll: "حذف الكل",
		ruSureToDeleteAll: "هل أنت متأكد من حذف جميع المهام؟",
		allDeleted: "تم حذف جميع المهام.",
		itisAlreadyEmpty: "لا يوجد مهام بالفعل",
	},
	en: {
		title: "Task List",
		dark: "Dark Mode 🌙",
		light: "Light Mode ☀️",
		placeholder: "Enter a new task...",
		add: "Add",
		noTasks: "No tasks currently",
		all: "All",
		incomplete: "Not yet ...",
		done: "Done",
		noOfAll: "Total number of tasks:",
		noOfDone: "Number of completed tasks:",
		noOfNot: "Number of incompleted tasks:",
		creator: "Created By : Hazem Abdullah",
		enterValidTask: "Please Enter a Task",
		wannaDeleteThisTask: "Are you sure you want to delete this task?",
		deleteAll: "Delete All",
		ruSureToDeleteAll: "Are you sure you want to delete all tasks?",
		allDeleted: "All tasks have been deleted.",
		itisAlreadyEmpty: "There are no tasks already",
	},
};

export default translations;
